
import Swiper from 'vux/src/components/swiper/swiper.vue'
import SwiperItem from 'vux/src/components/swiper/swiper-item.vue'

import { mapGetters, mapActions } from 'vuex';
export default {
components: { Swiper, SwiperItem },
name: 'square-curriculum',
data() {
return {
imgList: [
'./images/index_banner.jpg',
'./images/index_banner.jpg',
'./images/index_banner.jpg'
]
};
},
methods: {
...mapActions([])
},
watch: {},
computed: {
...mapGetters([])
},
created() {},
mounted() {}
};
